// @flow
import React from 'react';
import { IntlProvider } from 'react-intl';
import PropTypes from 'prop-types';
import i18nMessages from '../../../i18n';

import type { Node } from 'react';

type Props = {
  +locale: 'en' | 'es';
  +children: Node;
};

const Locale = (props: Props) => (
  <IntlProvider locale={props.locale}
                messages={i18nMessages[props.locale]}>
    {props.children}
  </IntlProvider>
);

Locale.propTypes = {
  locale: PropTypes.string.isRequired,
};

export default Locale;



// WEBPACK FOOTER //
// ./src/modules/locale/components/LocaleComponent.js